window.servicesPageService = {
    async getServicesPage(params = {}) {
        const response = await fetch(window.appConfig.routes.getServicesPage, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': window.appConfig.csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });

        if (!response.ok) {
            return { status: response.status, data: { tabs: [], groups: [] } };
        }

        return await response.json();
    },
};